module.exports = __webpack_public_path__ + "static/media/tip_dog_flea.940db1c1.png";